import { render, staticRenderFns } from "./add_receive_movement.vue?vue&type=template&id=f5da674a"
import script from "./add_receive_movement.vue?vue&type=script&lang=js"
export * from "./add_receive_movement.vue?vue&type=script&lang=js"
import style0 from "./add_receive_movement.vue?vue&type=style&index=0&id=f5da674a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports